import ThumbsUp from './ThumbsUp'

export default ThumbsUp
// eslint-disable-next-line import/export
export * from './ThumbsUp'
